import {
  SearchFilter,
  SearchFilterAvailabilityValue,
  SearchFilterType,
} from '@aibees/elephant/feature/search-filters/types';
import { SearchBrowseParams } from '@aibees/elephant/types';
import { getFilterFields } from '../../components/filter-tags/utils';

export function buildSearchParamsDraft(
  fields: string[],
  field: string,
  type?: SearchFilterType
) {
  const draft: Partial<SearchBrowseParams> = {};
  if (type === SearchFilterType.NOT_AVAILABLE)
    draft[field] = SearchFilterAvailabilityValue.NOT_AVAILABLE;
  fields
    .filter((x) => x !== field)
    .forEach((f) => {
      draft[f] = undefined;
    });
  return draft;
}

export function findCheckedRadio(
  items: SearchFilter[],
  filteringFields: string[],
  manuallyOpened?: string
) {
  const openManuallyList: string[] = [];
  const openByValueList: string[] = [];
  items.forEach((item) => {
    const subFields = getFilterFields(item);
    const openByValue = filteringFields.some((x) => subFields.includes(x));
    if (openByValue) openByValueList.push(item.field!);
    const openManually =
      item.type !== SearchFilterType.NOT_AVAILABLE &&
      manuallyOpened === item.field;
    if (openManually) openManuallyList.push(item.field!);
  });
  if (openByValueList.length) return openByValueList.at(0);
  return openManuallyList.at(0);
}
